import { AlertTriangle } from "lucide-react";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { EmptyState } from "../components/States";
import { Button } from "../components/ui/button";

/** Last-resort boundary for errors thrown while rendering or loading a route. */
export function RouteErrorPage() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <EmptyState
      className="h-full"
      icon={AlertTriangle}
      title={notFound ? "Page not found" : "Something went wrong"}
      description={
        notFound
          ? "The page you're looking for doesn't exist."
          : "An unexpected error occurred. Reload the page or go back to the app."
      }
      action={
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload
          </Button>
          <Button asChild>
            <Link to="/">Go home</Link>
          </Button>
        </div>
      }
    />
  );
}
